import * as yup from "yup";
import {
  MULTIMEDIA_MIME_TYPES,
  MULTIMEDIA_PLACEHOLDER,
  FILE_ALREADY_EXISTS,
} from "./../../../utils/constants";
import { useState } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { FaCircleNotch } from "react-icons/fa";
import { IoSaveOutline } from "react-icons/io5";
import { saveAccountDocumentsAsync } from "./../../../services/documentService";
import FileUpload from "../../../components/common/FileUpload";
import Toaster from "./../../../components/common/Toaster";

const schema = yup.object({
  files: yup.mixed().required("File is required."),
});

const DocumentForm = ({ id, isLoading, setLoading, onSuccess }) => {
  const [fileExists, setFileExists] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    clearErrors,
    formState: { errors },
  } = useForm({ resolver: yupResolver(schema) });

  const onSubmit = async (data) => {
    try {
      setLoading(true);
      await saveAccountDocumentsAsync(id, data);
      Toaster.Success("File Uploaded Successfully");
      onSuccess();
    } catch (ex) {
      if (ex.response && ex.response.data.message === FILE_ALREADY_EXISTS) {
        setFileExists(true);
      } else {
        Toaster.Error("Something went wrong.");
      }
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={handleSubmit(onSubmit)} className="p-8 space-y-6">
      <div className="grid grid-cols-2">
        <div className="col-span-2">
          <FileUpload
            id="files-dropdown"
            name="files"
            title="Files"
            setValue={setValue}
            clearErrors={clearErrors}
            register={register("files")}
            errors={errors}
            accepts={MULTIMEDIA_MIME_TYPES}
            placeholder={MULTIMEDIA_PLACEHOLDER}
            maxFiles={2}
            maxSize={5242880}
            multiple={true}
          />
          {fileExists && (
            <div className="pt-2">
              <span className="text-sm text-red-400">
                {FILE_ALREADY_EXISTS}
              </span>
            </div>
          )}
        </div>
      </div>
      <div className="grid grid-2 pt-2">
        <div className="col-span-2">
          <button
            type="submit"
            className="button button-primary disabled:opacity-70 disabled:cursor-not-allowed"
            disabled={isLoading}
          >
            {isLoading && <FaCircleNotch className="animate-spin mr-3" />}
            {!isLoading && <IoSaveOutline className="mr-3" />}
            Save Changes
          </button>
        </div>
      </div>
    </form>
  );
};

export default DocumentForm;
